import React from "react";
import { Button } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import { IoHomeOutline, IoArrowBackOutline } from "react-icons/io5";
import { MdErrorOutline } from "react-icons/md";

const PageNotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/dashboard");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="h-full w-full flex justify-center items-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="text-center max-w-md mx-auto px-6">
        {/* 404 Icon */}
        <div>
          <div className="relative">
            <MdErrorOutline className="text-8xl text-red-500 mx-auto mb-4" />
          </div>
        </div>
        <span className="text-6xl font-bold text-red-500">404</span>

        {/* Main Message */}
        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Page Not Found
        </h1>

        <p className="text-lg text-gray-600 mb-2">
          Oops! The page you're looking for doesn't exist
        </p>

        <p className="text-sm text-gray-500 mb-8">
          You may not have permission to access this page, or it has been moved.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            color="primary"
            variant="solid"
            startContent={<IoHomeOutline />}
            onPress={handleGoHome}
            className="font-medium"
          >
            Go to Dashboard
          </Button>

          <Button
            color="default"
            variant="bordered"
            startContent={<IoArrowBackOutline />}
            onPress={handleGoBack}
            className="font-medium"
          >
            Go Back
          </Button>
        </div>

        {/* Additional Info */}
        <div className="mt-8 text-xs text-gray-400">
          <p>
            If you believe this is an error, please contact your administrator.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
